import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GoToSubscriptionProps } from './GoToSubscription.props';

const GoToSubscription = ({ subscriptionUrl }: GoToSubscriptionProps) => {
  const navigate = useNavigate();

  function redirectToSubscription() {
    navigate(subscriptionUrl);
  }

  return (
    <Button variant="outlined" color="primary" onClick={redirectToSubscription}>
      Go to subscription
    </Button>
  );
};

export default GoToSubscription;
